<template>
    <div class="input-textarea">
        <b-form-group :id="'fieldset-' + id" v-bind="$attrs">
            <template v-if="useLabel" v-slot:label>{{ labelStr }} <span v-if="isRequired" class="required"></span></template>
            <div v-if="isAllowEdit && !isUpdatable">
                <b-form-textarea :class="useTextareaClass" :ref="'ref-input-' + id" v-bind="$attrs" v-model="inputModel" :formatter="inputFormatter" @keyup="$emit('update:model', inputModel);" @blur="$emit('change');"></b-form-textarea>
                <b-form-checkbox v-if="showModelExact" :id="'checkbox-' + id"  v-model="inputModelExact" @change="$emit('update:modelExact', inputModelExact)" :name="'checkbox-' + id" value="1" unchecked-value="0" >
                    <span class="col-form-label">exact</span>
                </b-form-checkbox>
                <b-form-invalid-feedback :id="'input-' + id + '-live-feedback'" :state="state">
                    {{ errorMessage }}
                </b-form-invalid-feedback>
            </div>
            <div :class="useLabel ? 'input-label-detail' : ''" v-else-if="isUpdatable">
                <span>
                    <app-long-text :maxLength="txtMaxLength" :text="inputModel != '' && inputModel != null ? inputModel : '-'" />
                </span>
                <span class="float-right"><a  v-if="isAllowEdit" @click="onPopoverShow" :id="'popover-button-sync-' + groupId"><app-icon-edit /></a></span>
            </div>
            <div v-else>
                {{ inputModel }}
            </div>
        </b-form-group>
        <b-popover :show.sync="popoverShow" :target="'popover-button-sync-' + groupId" :title="label" placement="bottomleft">
            <b-form-textarea v-bind="$attrs" rows="3" class="textarea-popover" v-model="popoverInputModel" :formatter="inputFormatter"></b-form-textarea>
            <div class="popover-action float-right mt-2 mb-1">
                <b-button @click="popoverShow = false" size="sm" class="btn-default-white">Cancel</b-button>
                <b-button @click="inputUpdate" size="sm" class="btn-default ml-2">Save</b-button>
            </div>
        </b-popover>
    </div>
</template>
<style lang="scss" scoped>
.textarea-popover {
    height: auto !important;
}
.input-textarea {
    .input-label-detail {
        line-height: 1.3 !important;
        height: max-content;
    }
}
</style>
<script>
export default {
    props: ["model", "modelExact", "errorMessage", "id", "state", "isEditable", "isUpdatable", "change", "label", "isRequired", "nolabel", "textareaClass", "maxLength"],
    data() {
        return {
            labelStr: this.label,
            inputModel: this.model,
            inputModelExact:this.modelExact,
            showModelExact:this.modelExact ? true : false,
            groupId : "fieldset-textarea-" + this.id,
            popoverShow: false,
            popoverInputModel: this.model,
        }
    }, 
    methods: {
        inputUpdate() {
            if (this.isUpdatable) {
                this.inputModel = this.popoverInputModel;
                this.$emit('update:model', this.inputModel);
                this.$emit('change');
                this.popoverShow = false;
            } else {
                this.$emit('update:model', this.inputModel);
                this.$emit('change');
            }
        },
        inputFormatter(value) {
            return value;
        },
        onPopoverShow() {
            this.popoverInputModel = this.inputModel;
            this.popoverShow = true;
        }
    },
    computed : {
        isAllowEdit : {
            get: function() {
                if (this.isEditable != undefined) return this.isEditable;
                else return true;
            }
        },
        useLabel() {
            if (this.nolabel != null && this.nolabel != undefined && this.nolabel != '') {
                if (this.nolabel) return false;
            }
            return true;
        },
        txtMaxLength() {
            if (this.maxLength != null && this.maxLength != undefined && this.maxLength != '') {
                return this.maxLength;
            }
            return 0;
        },
        useTextareaClass() {
            if (this.textareaClass != null && this.textareaClass != undefined && this.textareaClass != '') {
                if (this.textareaClass) return this.textareaClass;
            }
            return "";
        }
    },
    watch: {
        model(newValue) {
            this.inputModel = newValue
        },
        modelExact(newValue) {
            this.inputModelExact = newValue
        }
    }
}
</script>